var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLike14X14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5767 3.33963C11.3229 3.09588 11.0214 2.9025 10.6895 2.77055C10.3576 2.6386 10.0017 2.57068 9.64236 2.57068C9.28299 2.57068 8.92716 2.6386 8.59523 2.77055C8.26331 2.9025 7.96181 3.09588 7.70801 3.33963L6.99964 4.0183L6.29127 3.33963C5.77812 2.84799 5.08213 2.57179 4.35642 2.57179C3.63071 2.57179 2.93472 2.84799 2.42156 3.33963C1.90841 3.83127 1.62012 4.49808 1.62012 5.19336C1.62012 5.88864 1.90841 6.55544 2.42156 7.04708L3.12993 7.72575L7.00268 11.4293L10.8714 7.72284L11.5797 7.04417C11.8337 6.80086 12.035 6.51197 12.1723 6.19404C12.3096 5.87611 12.3801 5.53537 12.3798 5.1913C12.3795 4.84724 12.3085 4.5066 12.1707 4.18887C12.0328 3.87115 11.831 3.58256 11.5767 3.33963Z",
    fill: "#CDD3E0",
    stroke: "#CDD3E0",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLike14X14);
export default __webpack_public_path__ + "static/media/mobile-like-14x14.e73071fd511379d53ddb2d23631ea9bc.svg";
export { ForwardRef as ReactComponent };